export default {
  roleName: 'Role Name',
  roleDescription: 'Role Description',
  category: 'Category',
  permissionName: 'Permission Name',
  permissionDescription: 'Permission Description',
  selectAll: 'Select All',
  error702: 'Duplicate Role Name'
}
